import DOMPurify from 'dompurify'

export default defineNuxtPlugin(() => {
  if (typeof window !== 'undefined') {
    ;(window as any).__dompurify = DOMPurify
  }
})
